

























































































































































import { Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import Commit from "./commit.vue";
import Plugin from "./plugin.vue";
import Tester from "./tester.vue";
import Qrcode from "./qrcode.vue";
import Domain from "./domain.vue";
import Webviewdomain from "./webviewdomain.vue";
import Name from "./name.vue";
import HeadImage from "./headimage.vue";
import Signature from "./signature.vue";
import Categories from "./categories.vue";

import Wxasearchstatus from "./wxasearchstatus.vue";
import Wxaauth from "./wxaauth.vue";
import Wxaicp from "./wxaicp.vue";

@Component({
  components: {
    Commit,
    Plugin,
    Tester,
    Qrcode,
    Domain,
    Webviewdomain,
    Name,
    HeadImage,
    Signature,
    Categories,
    Wxasearchstatus,
    Wxaauth,
    Wxaicp
  }
})
export default class extends Mixins(MyForm) {
  @Prop() appid!: string;
  @Prop() qrcode!:string;
  @Prop() auth!:number;
  @Prop() icp!:number;

  baseinfo: any = {};

  commitModalVisible = false;

  pluginModalVisible = false;

  testerModalVisible = false;

  qrcodeModalVisible = false;

  domainModalVisible = false;

  nameModalVisible = false;

  headImageModalVisible = false;

  signatureModalVisible = false;

  webviewdomainModalVisible = false;

  categoriesModalVisible = false;

  wxasearchstatusModalVisible = false;

  wxaauthModalVisible = false;
  wxaicpModalVisible = false;

  showCommitModal() {
    this.commitModalVisible = true;
  }

  hideCommitModal() {
    this.commitModalVisible = false;
  }

  showPluginModal() {
    this.pluginModalVisible = true;
  }

  hidePluginModal() {
    this.pluginModalVisible = false;
  }

  showTesterModal() {
    this.testerModalVisible = true;
  }

  hideTesterModal() {
    this.testerModalVisible = false;
  }

  showQrcodeModal() {
    this.qrcodeModalVisible = true;
  }

  hideQrcodeModal() {
    this.qrcodeModalVisible = false;
  }

  showDomainModal() {
    this.domainModalVisible = true;
  }

  hideDomainModal() {
    this.domainModalVisible = false;
  }

  showNameModal() {
    this.nameModalVisible = true;
  }

  hideNameModal() {
    this.nameModalVisible = false;
  }

  showHeadImageModal() {
    this.headImageModalVisible = true;
  }

  hideHeadImageModal() {
    this.headImageModalVisible = false;
  }

  showSignatureModal() {
    this.signatureModalVisible = true;
  }

  hideSignatureModal() {
    this.signatureModalVisible = false;
  }

  showWebviewdomainModal() {
    this.webviewdomainModalVisible = true;
  }

  hideWebviewdomainModal() {
    this.webviewdomainModalVisible = false;
  }

  showCategoriesModal() {
    this.categoriesModalVisible = true;
  }

  hideCategoriesModal() {
    this.categoriesModalVisible = false;
  }

  showWxasearchstatusModal() {
    this.wxasearchstatusModalVisible = true;
  }

  hideWxasearchstatusModal() {
    this.wxasearchstatusModalVisible = false;
  }

  showWxaauthModal(){
    this.wxaauthModalVisible = true;
  }

  hideWxaauthModal(){
    this.wxaauthModalVisible = false;
  }

  showWxaicpModal(){
    this.wxaicpModalVisible = true;
  }

  hideWxaicpModal(){
    this.wxaicpModalVisible = false;
  }

  setprivacysetting() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要设置小程序用户隐私保护指引吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/setprivacysetting", {
          appid: this.appid
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  async searchPrivacysetting() {
    const res = await this.$store.dispatch("oplatformapps/getprivacysetting", {
      appid: this.appid
    });
    if (res && res.Message && res.Message === "success") {
      const h: any = this.$createElement;
      this.$info({
        title: "小程序用户隐私保护指引",
        content: h("div", {}, JSON.stringify(res.Data))
      });
    } else {
      this.$message.error(res.Message);
    }
  }

  async getLatestAuditstatus() {
    const res = await this.$store.dispatch("oplatformapps/getLatestAuditstatus", {
      appid: this.appid
    });

    // console.log(res);
    if (res && res.Message && res.Message === "success") {
      const h: any = this.$createElement;
      this.$info({
        title: "审核结果",
        content: h("div", {}, [
          h("p", `审核id：${res.Data.auditid}`),
          h("p", `审核状态：${res.Data.status}`),
          h("p", `原因：${res.Data.reason}`),
          h("p", `截图：${res.Data.screenshot}`)
        ])
      });
    } else {
      this.$message.error(res.Message);
    }
  }

  auditStatus(status: number) {
    if (status == 3) {
      return "已撤回";
    } else if (status == 2) {
      return "审核中";
    } else if (status == 1) {
      return "审核被拒绝";
    } else {
      return "审核成功";
    }
  }

  handleSubmitAudit() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要提交审核吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/submitAudit", {
          appid: this.appid
        });

        if (res && res.Message && res.Message === "success") {
          this.$message.success("成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  handleRelease() {
    this.showTsConfirm({
      title: "确认信息",
      content: "你确定要发布已审核的版本吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("oplatformapps/release", {
          appid: this.appid
        });

        if (res && res.Message && res.Message === "success") {
          this.$message.success("成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  mounted() {
    this.loadAccountBasicinfo();
  }

  async loadAccountBasicinfo() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("oplatformapps/getaccountbasicinfo", {
      appid: this.appid
    });
    //   console.log(res);
    if (res && res.Data) {
      this.baseinfo = res.Data;
    }

    this.spinLoading = false;
  }

  renderAccountType(accountType: number) {
    let str = "";
    switch (accountType) {
      case 1:
        str = "订阅号";
        break;
      case 2:
        str = "服务号";
        break;
      case 3:
        str = "小程序";
        break;
      default:
        break;
    }

    return str;
  }

  renderPrincipalType(principalType: number) {
    let str = "个人";
    if (principalType == 1) {
      str = "企业";
    } else if (principalType == 2) {
      str = "媒体";
    } else if (principalType == 3) {
      str = "政府";
    } else if (principalType == 4) {
      str = "其他组织";
    }

    return str;
  }

  renderRealnameStatus(status: number) {
    let str = "";
    switch (status) {
      case 1:
        str = "实名验证成功";
        break;
      case 2:
        str = "实名验证中";
        break;
      case 3:
        str = "实名验证失败";
        break;
      default:
        break;
    }
    return str;
  }
}
